module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newFlicker"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("闪屏管理 >\n        "), (_vm.edit === false) ? _c('span', [_vm._v("新增闪屏")]) : _vm._e(), _vm._v(" "), (_vm.edit !== false) ? _c('span', [_vm._v("编辑闪屏")]) : _vm._e(), _vm._v(" "), _c('span', [_c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.save(0)
      }
    }
  }, [_vm._v("保存草稿")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.save(1)
      }
    }
  }, [_vm._v("发布")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('el-form', {
    ref: "flickerForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.flickerForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "终端：",
      "prop": "appSource"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.flickerForm.appSource),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "appSource", $$v)
      },
      expression: "flickerForm.appSource"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.flickerForm.appSource),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "appSource", $$v)
      },
      expression: "flickerForm.appSource"
    }
  }, [_vm._v("安卓")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.flickerForm.appSource),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "appSource", $$v)
      },
      expression: "flickerForm.appSource"
    }
  }, [_vm._v("IOS")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "广告说明：",
      "prop": "description"
    }
  }, [_c('el-input', {
    staticClass: "flickerTitle",
    attrs: {
      "placeholder": "广告说明"
    },
    model: {
      value: (_vm.flickerForm.description),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "description", $$v)
      },
      expression: "flickerForm.description"
    }
  })], 1), _vm._v(" "), _c('select-school', {
    attrs: {
      "schObj": _vm.flickerForm.schObj
    },
    on: {
      "changeVal": _vm.getVal
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "起止日期：",
      "prop": "qizhiDate",
      "required": ""
    }
  }, [_c('el-form-item', {
    staticClass: "time",
    attrs: {
      "prop": "startTime"
    }
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": "yyyy/MM/dd"
    },
    model: {
      value: (_vm.flickerForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "startTime", $$v)
      },
      expression: "flickerForm.startTime"
    }
  })], 1), _vm._v("\n                  至  \n                "), _c('el-form-item', {
    staticClass: "time",
    attrs: {
      "prop": "endTime"
    }
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": "yyyy/MM/dd"
    },
    model: {
      value: (_vm.flickerForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "endTime", $$v)
      },
      expression: "flickerForm.endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主标题：",
      "prop": "mainTitle"
    }
  }, [_c('el-input', {
    staticClass: "flickerTitle",
    attrs: {
      "placeholder": "请填写正确的主标题，不超过10个字符"
    },
    model: {
      value: (_vm.flickerForm.mainTitle),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "mainTitle", $$v)
      },
      expression: "flickerForm.mainTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "副标题：",
      "prop": "subTitle"
    }
  }, [_c('el-input', {
    staticClass: "flickerTitle",
    attrs: {
      "placeholder": "请填写正确的副标题，不超过14个字符"
    },
    model: {
      value: (_vm.flickerForm.subTitle),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "subTitle", $$v)
      },
      expression: "flickerForm.subTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "LOGO：",
      "prop": "logo"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.logoActionUrl,
      "with-credentials": true,
      "accept": "image/*",
      "name": "picFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "on-success": _vm.handleSuccess_logo
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或\n                        "), _c('em', [_vm._v("点击上传")])])]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("（尺寸说明：88×88像素，jpg、jpeg、png）")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点击事件：",
      "prop": "type",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "-1"
    },
    model: {
      value: (_vm.flickerForm.type),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "type", $$v)
      },
      expression: "flickerForm.type"
    }
  }, [_vm._v("无跳转")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.flickerForm.type),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "type", $$v)
      },
      expression: "flickerForm.type"
    }
  }, [_vm._v("跳转至URL：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.flickerForm.type),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "type", $$v)
      },
      expression: "flickerForm.type"
    }
  }, [_vm._v("跳转至微信小程序：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.flickerForm.type),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "type", $$v)
      },
      expression: "flickerForm.type"
    }
  }, [_vm._v("跳转至支付宝小程序：")])], 1), _vm._v(" "), (_vm.flickerForm.type === '1') ? _c('el-form-item', {
    staticClass: "wxApp-from-1",
    attrs: {
      "prop": "urlAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的URL地址"
    },
    model: {
      value: (_vm.flickerForm.urlAddress),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "urlAddress", $$v)
      },
      expression: "flickerForm.urlAddress"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.flickerForm.type == '2') ? _c('div', [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "小程序原始ID：",
      "prop": "wxAppId",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的小程序原始ID"
    },
    model: {
      value: (_vm.flickerForm.wxAppId),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "wxAppId", $$v)
      },
      expression: "flickerForm.wxAppId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "路径地址："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的路径地址"
    },
    model: {
      value: (_vm.flickerForm.wxAppUrl),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "wxAppUrl", $$v)
      },
      expression: "flickerForm.wxAppUrl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.flickerForm.type == '3') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "小程序原始ID：",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的小程序原始ID"
    },
    model: {
      value: (_vm.flickerForm.aliAppId),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "aliAppId", $$v)
      },
      expression: "flickerForm.aliAppId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "路径地址："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的路径地址"
    },
    model: {
      value: (_vm.flickerForm.aliAppUrl),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "aliAppUrl", $$v)
      },
      expression: "flickerForm.aliAppUrl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "闪屏图片：",
      "prop": "picture"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.pictureActionUrl,
      "with-credentials": true,
      "accept": "image/*",
      "name": "picFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "on-success": _vm.handleSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或\n                        "), _c('em', [_vm._v("点击上传")])])]), _vm._v(" "), _c('span', {
    staticClass: "gray"
  }, [_vm._v("（尺寸说明：750×1125像素，jpg、jpeg、GIF、png）")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "bannerContent",
    attrs: {
      "label": "广告曝光代码:",
      "prop": "adExposingCodes"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5
      },
      "placeholder": "在这里粘贴"
    },
    model: {
      value: (_vm.flickerForm.adExposingCodes),
      callback: function($$v) {
        _vm.$set(_vm.flickerForm, "adExposingCodes", $$v)
      },
      expression: "flickerForm.adExposingCodes"
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-509c0420!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/flicker/newFlickerScreen.vue
// module id = 1026
// module chunks = 0